/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Outbound_Title8Inputs */

const en_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outbound campaigns`)
};

const ar_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حملات صادرة`)
};

const bn_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আউটবাউন্ড ক্যাম্পেইন`)
};

const de_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgehende Kampagnen`)
};

const es_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campañas salientes`)
};

const fr_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campagnes sortantes`)
};

const pt_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campanhas ativas`)
};

const zh_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`外呼营销`)
};

const tr_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giden kampanyalar`)
};

const ru_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исходящие кампании`)
};

const pl_svc_ai_voice_agents_outbound_title8 = /** @type {(inputs: Svc_Ai_Voice_Agents_Outbound_Title8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampanie wychodzące`)
};

/**
* | output |
* | --- |
* | "Outbound campaigns" |
*
* @param {Svc_Ai_Voice_Agents_Outbound_Title8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_outbound_title8 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Outbound_Title8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Outbound_Title8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_outbound_title8(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_outbound_title8(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_outbound_title8(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_outbound_title8(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_outbound_title8(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_outbound_title8(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_outbound_title8(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_outbound_title8(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_outbound_title8(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_outbound_title8(inputs)
	return en_svc_ai_voice_agents_outbound_title8(inputs)
});
export { svc_ai_voice_agents_outbound_title8 as "svc_ai-voice-agents_OUTBOUND_title" }